export enum WebSocketStreamDataType {
    Start = 'START',
    End = 'END',
    Content = 'CONTENT',
    Error = 'ERROR',
}
